/**
 * Product availability status management
 */

function setStatusInfo(availabilityContainer, quantity) {
    if (!availabilityContainer) return;

    const productData = availabilityContainer.dataset;
    let statusEl = availabilityContainer.querySelector('.js-availability-external');

    // Create the element if it doesn't exist
    if (!statusEl) {
        statusEl = document.createElement('div');
        statusEl.className = 'js-availability-external';
        const mainEl = availabilityContainer.querySelector('.c-availability__main');
        if (mainEl) {
            mainEl.appendChild(statusEl);
        } else {
            availabilityContainer.appendChild(statusEl);
        }
    }

    const redColor = '#e60000';
    let stock = parseFloat(productData.stock) || 0;
    const externalStatus = productData.externalStatus || '';

    // Get translations from data attributes
    const pcs = productData.translationsPcs || 'ks';

    if (stock < 0) stock = 0;

    if (quantity > stock) {
        let statusHtml = '';

        // Show external status if available
        if (externalStatus) {
            statusHtml += `<div>${externalStatus.replace(new RegExp(`^\\d+${pcs} `), '')}</div>`;
        }

        statusEl.innerHTML = statusHtml;
    } else {
        // Clear external status when quantity is within stock
        statusEl.innerHTML = '';
    }
}

function setStatusInfoById(id, quantity) {
    const $product = document.querySelector(`.js-shopping-product[data-cart-id="${id}"], .cart-product[data-cart-id="${id}"]`);

    if ($product) {
        setStatusInfo($product, quantity);
    }
}

function updateProductPageStatus(quantityInput) {
    const quantity = parseInt(quantityInput.value) || 1;
    const availabilityContainer = document.querySelector('.c-availability[data-stock]');

    if (availabilityContainer) {
        setStatusInfo(availabilityContainer, quantity);
    }
}

function initializeAvailabilityStatus() {
    // Cart products
    document.querySelectorAll('.js-shopping-product, .cart-product').forEach(product => {
        const quantityInput = product.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? quantityInput.value : 1;

        setStatusInfo(product, parseInt(quantity));
    });

    // Product detail pages
    const availabilityContainer = document.querySelector('.c-availability[data-stock]');
    if (availabilityContainer) {
        const quantityInput = document.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? quantityInput.value : 1;

        setStatusInfo(availabilityContainer, parseInt(quantity));

        // Watch for quantity changes on product pages
        if (quantityInput) {
            quantityInput.addEventListener('input', () => updateProductPageStatus(quantityInput));
            quantityInput.addEventListener('change', () => updateProductPageStatus(quantityInput));
        }
    }
}

function setupVariationObserver() {
    // Watch for dynamic element changes (when variations change)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                const addedNodes = Array.from(mutation.addedNodes);
                addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const availabilityContainer = node.querySelector ? node.querySelector('.c-availability[data-stock]') : null;
                        if (availabilityContainer || (node.classList && node.classList.contains('c-availability') && node.dataset.stock)) {
                            const container = availabilityContainer || node;
                            const quantityInput = document.querySelector('input[name="quantity"]');
                            const quantity = quantityInput ? quantityInput.value : 1;

                            setStatusInfo(container, parseInt(quantity));
                        }
                    }
                });
            }
        });
    });

    // Observe changes in dynamic elements
    const dynamicElements = document.querySelectorAll('[r-dynamic-element]');
    dynamicElements.forEach((element) => {
        observer.observe(element, { childList: true, subtree: true });
    });
}

// Auto-initialize when the module is loaded
document.addEventListener("DOMContentLoaded", () => {
    initializeAvailabilityStatus();
    setupVariationObserver();
});

// Cart update callback
window.rEvent.on("Custom.Cart.updatedItem", (data) => {
    const parent = data.input.closest(".cart-product");

    if (parent) {
        const quantity = parseInt(data.input.value) || 1;
        setStatusInfo(parent, quantity);
    }
});